export const BUSINESS_MODES = {
  HOSPITALITY_RETAIL: "hospitality_retail",
  SECURITY_SERVICES: "security_services",
  CLEANING_SERVICES: "cleaning_services",
  FIELD_SERVICES: "field_services",
};

export function normalizeBusinessMode(value) {
  const raw = String(value || "").trim().toLowerCase();

  if (!raw) return BUSINESS_MODES.HOSPITALITY_RETAIL;
  if (raw.includes("security")) return BUSINESS_MODES.SECURITY_SERVICES;
  if (raw.includes("clean")) return BUSINESS_MODES.CLEANING_SERVICES;
  if (raw.includes("field")) return BUSINESS_MODES.FIELD_SERVICES;
  if (raw.includes("service")) return BUSINESS_MODES.FIELD_SERVICES;
  if (raw.includes("patrol")) return BUSINESS_MODES.SECURITY_SERVICES;
  if (raw.includes("guard")) return BUSINESS_MODES.SECURITY_SERVICES;
  return BUSINESS_MODES.HOSPITALITY_RETAIL;
}

export function isFieldOpsMode(mode) {
  const normalized = normalizeBusinessMode(mode);
  return (
    normalized === BUSINESS_MODES.SECURITY_SERVICES ||
    normalized === BUSINESS_MODES.CLEANING_SERVICES ||
    normalized === BUSINESS_MODES.FIELD_SERVICES
  );
}

export function modeLabel(mode) {
  const normalized = normalizeBusinessMode(mode);
  switch (normalized) {
    case BUSINESS_MODES.SECURITY_SERVICES:
      return "Security Services";
    case BUSINESS_MODES.CLEANING_SERVICES:
      return "Cleaning Services";
    case BUSINESS_MODES.FIELD_SERVICES:
      return "Field Services";
    default:
      return "Hospitality / Retail";
  }
}

export function extractBusinessModeFromOrgData(data = {}) {
  return normalizeBusinessMode(
    data?.businessMode ||
      data?.industryMode ||
      data?.appMode ||
      data?.orgMode ||
      data?.companyType ||
      data?.vertical ||
      data?.sector ||
      ""
  );
}

export function extractAppVariantFromOrgData(data = {}, fallbackMode) {
  const raw = String(
    data?.appVariant || data?.deviceMode || data?.attendanceMode || ""
  )
    .trim()
    .toLowerCase();

  if (raw.includes("personal")) return "personal_device";
  if (raw.includes("shared")) return "shared_device";
  return isFieldOpsMode(fallbackMode) ? "personal_device" : "shared_device";
}

export function readStoredBusinessContext() {
  const installParams = safeReadJSON("installParams");
  const businessMode = normalizeBusinessMode(
    localStorage.getItem("businessMode") ||
      localStorage.getItem("orgBusinessMode") ||
      installParams?.businessMode ||
      ""
  );

  const appVariant =
    localStorage.getItem("appVariant") ||
    localStorage.getItem("orgAppVariant") ||
    installParams?.appVariant ||
    (isFieldOpsMode(businessMode) ? "personal_device" : "shared_device");

  return { businessMode, appVariant, installParams };
}

export function persistBusinessContext({ businessMode, appVariant } = {}) {
  const normalizedMode = normalizeBusinessMode(businessMode);
  const normalizedVariant =
    appVariant || (isFieldOpsMode(normalizedMode) ? "personal_device" : "shared_device");

  try {
    localStorage.setItem("businessMode", normalizedMode);
    localStorage.setItem("orgBusinessMode", normalizedMode);
    localStorage.setItem("appVariant", normalizedVariant);
    localStorage.setItem("orgAppVariant", normalizedVariant);

    const current = safeReadJSON("installParams") || {};
    localStorage.setItem(
      "installParams",
      JSON.stringify({
        ...current,
        businessMode: normalizedMode,
        appVariant: normalizedVariant,
      })
    );
  } catch {
    // ignore storage failures
  }

  return {
    businessMode: normalizedMode,
    appVariant: normalizedVariant,
  };
}

function safeReadJSON(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || "null");
  } catch {
    return null;
  }
}
